import { courses } from "@/mocks/homeData";

const tagColors: Record<string, string> = {
  "Best Seller": "bg-amber-100 text-amber-700",
  "Popular": "bg-emerald-100 text-emerald-700",
  "New": "bg-rose-100 text-rose-700",
  "Top Rated": "bg-violet-100 text-violet-700",
};

export default function CoursesSection() {
  return (
    <section id="courses" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full border border-amber-300 text-amber-700 text-xs font-semibold tracking-widest uppercase mb-4">
              Featured Programs
            </span>
            <h2
              className="text-3xl md:text-4xl font-bold text-gray-900"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Our Most Popular Courses
            </h2>
          </div>
          <a
            href="#booking"
            className="whitespace-nowrap text-sm font-semibold text-amber-600 hover:text-amber-700 flex items-center gap-1 cursor-pointer"
          >
            View all programs <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {courses.map((course) => (
            <div
              key={course.id}
              className="bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-amber-200 transition-all duration-300 cursor-pointer group"
            >
              {/* Image */}
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={course.image}
                  alt={course.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${tagColors[course.tag]}`}>
                    {course.tag}
                  </span>
                </div>
              </div>

              {/* Info */}
              <div className="p-5">
                <h3 className="font-bold text-gray-900 text-base mb-1 leading-snug">{course.title}</h3>
                <p className="text-gray-400 text-xs mb-3">{course.subtitle}</p>

                <div className="flex items-center gap-3 text-xs text-gray-500 mb-4 flex-wrap">
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line"></i> {course.level}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> {course.sessions}
                  </span>
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-1">
                    <i className="ri-star-fill text-amber-400 text-xs"></i>
                    <span className="text-xs font-semibold text-gray-700">{course.rating}</span>
                    <span className="text-xs text-gray-400">({course.reviews})</span>
                  </div>
                  <span className="text-base font-bold text-gray-900">{course.price}</span>
                </div>

                <a
                  href="#booking"
                  className="mt-4 block w-full text-center py-2.5 rounded-xl bg-amber-500 text-white text-sm font-semibold hover:bg-amber-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Enroll Now
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
